import { z } from "zod";
import { baseEntitySchema } from "./base";

export const inventoryLedgerEventTypeSchema = z.enum([
  "allocation",
  "deallocation",
  "stock_check_adjustment",
  "manual_adjustment",
]);
export type InventoryLedgerEventType = z.infer<
  typeof inventoryLedgerEventTypeSchema
>;

export const inventoryLedgerDataSchema = z.object({
  inventoryId: z.string().optional(),
  eventType: inventoryLedgerEventTypeSchema,
  deltaMiles: z.number(),
  resultingMilesLeftSystem: z.number(),
  referenceType: z.string(),
  referenceId: z.string(),
  createdBy: z.string(),
});

export type InventoryLedgerData = z.infer<typeof inventoryLedgerDataSchema>;
export const inventoryLedgerSchema = baseEntitySchema.merge(
  inventoryLedgerDataSchema,
);
export type InventoryLedger = z.infer<typeof inventoryLedgerSchema>;
